import React, { useContext } from 'react'
import { Segmented } from 'antd'
import { getLanguageFlag, getLanguageName, getAllLanguages, Flag, calculateProjectsByLanguage } from '../utils.js'
import { Context } from '../context.js'
import { Tag } from 'antd';

export function TableSettingsLangs({ value = 'all', handleChange = () => { } }) {

  const context = useContext(Context);

  const options = [
    {
      label: <div className="_f">
        <div>Все</div>
        {/* <div
          className="_fcc"
          style={{
            fontSize: '0.8em',
            padding: '0.4em',
            color: '#999',
            borderRadius: '2em',
            background: '#e9e9e9',
            height: '1.2em',
            marginBottom: '-0.1em',
          }}>{calculateProjectsByLanguage(context.data, 'all')}</div> */}
      </div>,
      value: 'all',
    },
    // Generate language options dynamically for all languages
    ...getAllLanguages().map(langId => ({
      label: <div className="_f _fm _fgap02">
        <Flag langId={langId} height={10} shadow />
        <div>{getLanguageName(langId)}</div>
        {/* <div
          className="_fcc"
          style={{
            fontSize: '0.8em',
            padding: '0.4em',
            color: '#999',
            borderRadius: '2em',
            background: '#e9e9e9',
            height: '1.2em',
            marginBottom: '-0.1em',
          }}>{calculateProjectsByLanguage(context.data, langId)}</div> */}
      </div>,
      value: langId,
    }))
  ]

  return (

    <Segmented
      value={value}
      onChange={handleChange}
      options={options}
    />

  )
}
